import { createContext, useContext, useState } from "react";

const DemoLoadContext = createContext();

export function DemoLoadProvider({ children }) {
  const [hideDemoLoad, setHideDemoLoad] = useState(false);
  return (
    <DemoLoadContext.Provider value={{ hideDemoLoad, setHideDemoLoad }}>
      {children}
    </DemoLoadContext.Provider>
  );
}

export const useDemoLoad = () => useContext(DemoLoadContext);
